import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from '../common/loadingComponent';
import { connect } from 'react-redux';
import { domainActions } from '../../store/domainStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form } from 'formik';
import { hasPermission } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { windowActions } from '../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from "react-router"
import classnames from 'classnames';
import FormMenuControl from '../common/formMenuControl';
import Overviews from './ratioBookSummaryOverviewsForm'
import RatioBookCodeListResult from './ratioBookCodeListResult';
import RatioBookMethodology from './ratioBookMethodology';
import RatioBookNaceField from './rbNace'
import RatioBookYearsField from './rbYears'
import SearchTip from '../common/searchTip';
import Section from "../common/section";
import TabLink from '../search/tabLink';

import IconOverview from '../../img/icons/BBiconsStredniHodnotySouhrnnePrehledy';
import IconBranches from '../../img/icons/BBiconsStredniHodnotyOdvetvi';
import IconCodeLists from '../../img/icons/BBiconsCiselniky';
import IconMethodology from '../../img/icons/BBiconsMetodika';

const searchTypes = {
    overview: "overview",
    branches: "branches",
    codeLists: "codeLists",
    methodology: "methodology"
};

const emptyYear = "";

export const codeListTypes = {
    districts: "districts",
    branches: "branches",
    legalForms: "legal-forms"
}

class RatioBookSearchForm extends React.Component {
    nacedatalist = [];

    state = {
        selected: searchTypes.branches,
        selectedYear: emptyYear
    }

    componentDidMount() {
        this.props.ensureDomainData('nace');
        this.props.ensureDomainData('ratiobookyears');
        this.getNaceList();
        this.setSelectedYear();
    }

    componentDidUpdate(prevProps, prevState) {
        this.props.ensureDomainData('nace');
        this.props.ensureDomainData('ratiobookyears');
        this.setSelectedYear();
    }

    render() {
        return (
            <div className="columns is-desktop">
                <div className="column is-4-desktop tabs tabs-form-menu" style={{ fontSize: "1em" }}>
                    <FormMenuControl>
                        <ul>
                            <TabLink type='methodology' selected={this.state.selected} onSelect={this.selectSearch} icon={<IconMethodology className="tabs-icon" />}
                                titleKey='RatioBook.Methodology' descriptionKey='RatioBook.Methodology.Description' hr={true} />
                            <TabLink type='overview' selected={this.state.selected} onSelect={this.selectSearch} icon={<IconOverview className="tabs-icon" />}
                                titleKey='RatioBook.SummaryOverviews' descriptionKey='RatioBook.SummaryOverviews.Description' hr={true} />
                            <TabLink type='branches' selected={this.state.selected} onSelect={this.selectSearch} icon={<IconBranches className="tabs-icon" />}
                                titleKey='RatioBook.Branches' descriptionKey='RatioBook.Branches.Description' hr={true} />
                            <TabLink type='codeLists' selected={this.state.selected} onSelect={this.selectSearch} icon={<IconCodeLists className="tabs-icon" />}
                                titleKey='RatioBook.CodeLists' descriptionKey='RatioBook.CodeLists.Description' hr={false} />
                        </ul>
                    </FormMenuControl>
                </div>
                <div className='column'>
                    {this.hasSearchTips(this.state.selected) &&
                        <SearchTip windowId={`tips_ratiobook_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-mobile" style={{ marginBottom: '-0.5em', marginTop: '1em' }} />}
                    <div className='card card-special'>
                        {this.hasSearchTips(this.state.selected) &&
                            <SearchTip windowId={`tips_ratiobook_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-desktop" style={{ marginBottom: '-2.5em', paddingTop: '1em', marginRight: '1em' }} />}
                        <div className='card-body'>
                            {this.renderForms()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderForms = () => {
        if (isNullOrUndefined(this.state.selectedYear) || this.state.selectedYear === '')
            return <Circles />

        return (
            <>
                <div className="columns">
                    <div className="column is-4">
                        <RatioBookYearsField fieldName='year' year={this.state.selectedYear} onChange={(year) => this.setState({ selectedYear: year })} />
                    </div>
                    <div className="column is-10"></div>
                </div>
                <hr />
                {this.state.selected === searchTypes.overview && <Overviews recentYear={this.state.selectedYear} />}
                {this.state.selected === searchTypes.branches && this.renderBranchesForm()}
                {this.state.selected === searchTypes.codeLists && this.renderCodeListsForm(this.state.selectedYear)}
                {this.state.selected === searchTypes.methodology && this.renderMethodologyForm(this.state.selectedYear)}
            </>
        );
    }

    renderBranchesForm = () => {
        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    nace: '01'
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    this.submitSearch(searchTypes.branches, values)
                }}
            >
                {({ values }) => (
                    <Form>
                        <div className="columns">
                            <div className="column is-12">
                                <RatioBookNaceField fieldName='nace' dataList={this.nacedatalist} />
                            </div>
                        </div>
                        <div className='columns m-0 is-centered has-text-centered'>
                            <div className='column is-narrow'>
                                <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    type='submit'
                                    style={{ fontWeight: 600 }}
                                    disabled={this.props.isSearching}
                                >
                                    {this.props.isSearching ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Search.Common.Search' />}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        );
    }

    renderCodeListsForm = (selectedYear) => {
        return (
            <div className="columns">
                <div className="column is-12">
                    {this.generateCodeListOptions().map((item) =>
                        <Section key={item.value} level={2} name={this.props.translate(item.label)}>
                            <RatioBookCodeListResult year={selectedYear} type={item.value} language={this.props.user.language} />
                        </Section>)
                    }
                </div>
            </div>
        );
    }

    renderMethodologyForm = (selectedYear) => {
        return (
            <div className="columns">
                <div className="column is-12">
                    <RatioBookMethodology year={selectedYear} language={this.props.user.language} />
                </div>
            </div>
        );
    }

    submitSearch(searchType, values) {
        if ((searchType === searchTypes.branches) && (this.state.selectedYear !== "" && values.nace !== "")) {
            this.props.history.push(`/search/ratiobook/branch/${this.state.selectedYear}/${values.nace}`);
        }
    }

    selectSearch = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({ selected: selected });
            this.props.closeAll();
        }
    }

    getNaceList() {
        const naceData = this.props.nace.requestResult ? this.props.nace.requestResult : []

        if (isNullOrUndefined(naceData))
            return null;

        if (this.nacedatalist.length > 0)
            return this.nacedatalist;

        const rawData = naceData.map((c) => {
            const l2 = c.children.map(item => {
                const ll1 = item;
                const ll2 = item.children;
                return [].concat.apply(ll1, ll2);
            });
            return [].concat.apply([], l2);
        });

        const data = [].concat.apply([], rawData.map((c) => c)).map(item => new NaceItem(item.shortening, item.label));
        this.nacedatalist = data;
        return data;
    }

    generateCodeListOptions = () => {
        return [
            { value: codeListTypes.districts, label: "RatioBook.CodeList.Districts" },
            { value: codeListTypes.branches, label: "RatioBook.CodeList.Branches" },
            { value: codeListTypes.legalForms, label: "RatioBook.CodeList.LegalForms" }
        ];
    }

    setSelectedYear = () => {
        if (isNullOrUndefined(this.state.selectedYear) || this.state.selectedYear === '') {
            const mostRecentYear = this.getMostRecentYear();

            if (this.state.selectedYear !== mostRecentYear) {
                this.setState({ selectedYear: mostRecentYear })
            }
        }
    }

    getMostRecentYear = () => {
        if (!isNullOrUndefined(this.props.ratiobookyears.requestResult) && this.props.ratiobookyears.requestResult.length > 0) {
            for (var i = 0; i < this.props.ratiobookyears.requestResult.length; i++) {
                if (hasPermission(null, "RatioBook" + this.props.ratiobookyears.requestResult[i].value))
                    return this.props.ratiobookyears.requestResult[i].value;
            }
            return "";
        }
        else return "";
    }

    hasSearchTips(searchType) {
        switch (searchType) {
            case searchTypes.branches:
            case searchTypes.methodology:
            case searchTypes.codeLists:
            case searchTypes.overview:
                return true;
            default:
                return false;
        }
    }

    getSearchTipsModel(searchType) {
        switch (searchType) {
            case searchTypes.branches:
                return { title: `${this.props.translate('RatioBook.Branches')}`, bodyHtml: this.props.translate('SearchTips.RatioBook.Branches.Body') };
            case searchTypes.methodology:
                return { title: `${this.props.translate('RatioBook.Methodology')}`, bodyHtml: this.props.translate('SearchTips.RatioBook.Methodology.Body') };
            case searchTypes.codeLists:
                return { title: `${this.props.translate('RatioBook.CodeLists')}`, bodyHtml: this.props.translate('SearchTips.RatioBook.CodeList.Body') };
            case searchTypes.overview:
                return { title: `${this.props.translate('RatioBook.SummaryOverviews')}`, bodyHtml: this.props.translate('SearchTips.RatioBook.Overview.Body') };
            default:
                    return undefined;
        }
    }
}

class NaceItem {
    constructor(id, label) {
        this.id = this.removeDots(id);
        this.label = this.removeNumberPart(label);
    }

    removeDots(text) {
        return text.split('.').join('');
    }

    removeNumberPart(text) {
        const splitText = text.split('-');
        return splitText[1].trim();
    }
}

export default withRouter(withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators({ ...domainActions, ...windowActions }, dispatch)
)(RatioBookSearchForm)));
